import { Input } from "antd"
import { TextAreaProvider } from "components/providers/Input.provider"
import { TOnChangeInput } from "types/default.type"
import { KeyboardEvent } from "react"

const { TextArea: AntTextArea } = Input

type Props = {
	value?: string
	placeholder: string
	minRows?: number
	onChange?: (args: TOnChangeInput) => void
	onKeyDown?: (e: KeyboardEvent<HTMLTextAreaElement>) => void
	className?: string
	name?: string
	onBlur?: () => void
}

export const TextArea = ({
	value,
	placeholder,
	minRows = 5,
	onChange,
	onKeyDown,
	className,
	name = "input",
	onBlur,
}: Props) => {
	return (
		<TextAreaProvider>
			<div style={{ width: "100%" }} data-testid="text-area">
				<AntTextArea
					className={className}
					value={value}
					onChange={onChange}
					onKeyDown={onKeyDown}
					placeholder={placeholder}
					autoSize={{ minRows: minRows }}
					name={name}
					onBlur={onBlur}
				/>
			</div>
		</TextAreaProvider>
	)
}
